import { Helmet } from 'react-helmet';
import {
  React,
  useState,
  useContext
} from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography
} from '@mui/material';
import Logo from '../components/Logo';
import { UserContext } from '../providers/UserProvider';
import {signIntoCloud} from 'src/DjangoAuth'


const Login = (props) => {

  const [checking, setChecking] =  useState(false);
  const [checkFailed, setCheckFailed] =  useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const {user, setUser} = useContext(UserContext);

  async function signInWithEmailAndPasswordHandler(event) {
    setChecking( true)
    event.preventDefault();

    try {
      signIntoCloud(email, password).then(json =>{
        if (json === "access denied"){
            setCheckFailed(true);
            setChecking(false);    
        }else{
            setUser(json)
        }

      });
    } catch (e) {
      // Handle invalid login here
      setError('Error signing in with password and email!');
      console.error('Error signing in with password and email', error);
    }
  }

  const logoStyle ={
    display: 'flex',
    paddingRight:"2%",
    paddingTop:"3%",
    justifyContent: 'center',
    alignItems: 'center'
  }

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };
  /* eslint-disable */
  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div style={logoStyle}>
      <Logo />
      <br/>
      <Typography
        color="primary"
        variant="h1"
      >
        Dashboard
      </Typography>
      </div>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '80%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <form onSubmit={signInWithEmailAndPasswordHandler}>
            <Box sx={{ mb: 3 }}>
              {checking ?
                <Typography
                  color="secondary"
                  variant="h2"
                >
                  Verifying Credentials please wait...
                  <br/> 
                </Typography>

                :
                <></>
              }
              {checkFailed ?
                <Typography
                  color="secondary"
                  variant="h2"
                >
                  Username or password is incorrect
                  <br/> 
                </Typography>

                :
                <></>
              }
              <Typography
                color="textPrimary"
                variant="h2"
              >
                Sign in
              </Typography>
            </Box>
            <TextField
              fullWidth
              label="Username"
              margin="normal"
              name="email"
              onChange={onChangeHandler}
              type="text"
              value={email}
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Password"
              margin="normal"
              name="password"
              onChange={onChangeHandler}
              type="password"
              value={password}
              variant="outlined"
            />
            <Box sx={{ py: 2 }}>
              <Button
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Sign in now
              </Button>
            </Box>
            {/*<Typography
              color="textSecondary"
              variant="body1"
            >
              Don&apos;t have an account?
              {' '}
              <Link
                wait={1000}
                component={RouterLink}
                to="/register"
                variant="h6"
              >
                Sign up
              </Link>
            </Typography>*/}
          </form>
        </Container>
      </Box>
    </>
  );
};

export default Login;
